<template>
    <div class="container">
      <div style="width: 1260px; margin: 0 auto; display: flex; height: 100%">
        <div class="tab">
          <div class="tab_title"><common-data name="appShortName_37"/></div>
          <!-- <div class="underline"></div> -->
          <ul>
            <li
              v-for="(item, index) in contentList"
              :key="index"
              class="tit-left-item"
              :class="{ active: index == id }"
              @click="selectContent(item.id)"
            >
              <span>{{ item.name }}</span
              >
            </li>
          </ul>
        </div>
        <div class="content">
          <div class="con-text">
            
            <div class="text-txt">
              <div class="wrap" >
                <div v-if="id == 0">
                    
                    <div class="paragraph">
                        <common-data name="appShortName_37"/>提供量价类-技术指标、量价类-波动率因子、财务类、公司资料类等十几个大类133个开源系统因子。 
                    </div>
                    <div class="paragraph">
                       系统因子Python源代码的开放，可以帮助理解因子编写逻辑，也为自编因子提供完善的基础代码框架和编写示例。
                    </div>
                    <div class="paragraph">
                       软件的策略案例，也是完全采用开源因子库里的因子来构建的，实现了还不错的收益率表现。
                    </div>
                    <BaseBigimg
                      :src="require('./imageswh10/kyyzk2.png')"
                    ></BaseBigimg>
                    <div class="paragraph">
                       开源因子列表：
                    </div>
                    <table class="buytable" style="margin-top:1px">
                      <tr>
                        <td width="100px" style="text-align:center;">因子类别</td>
                        <td width="200px" style="text-align:center">分类</td>
                        <td style="text-align:center">说明</td>
                        <td width="100px" style="color:white;text-align:center">数量</td>
                      </tr>
                       <tr>
                      <td rowspan="13" style="text-align:center">股票因子</td>
                      <td>量价类-技术指标</td>
                      <td rowspan="6">技术、波动率、换手率、成交量等量价类因子；</td>
                      <td>25</td>
                  </tr>
                  <tr>
                      <td>量价类-波动率因子</td>
                      <td >4</td>
                  </tr>
                  <tr>
                      <td>量价类-换手率因子</td>
                      <td>2</td>
                  </tr>
                  <tr>
                      <td>量价类-成交量因子</td>
                      <td>4</td>
                  </tr>
                  <tr>
                      <td>量价类-资金流向因子</td>
                      <td>4</td>
                  </tr>
                  <tr>
                      <td>量价类-横向比较</td>
                      <td>1</td>
                  </tr>
                  <tr>
                      <td>财务类-盈利能力</td>
                      <td rowspan="6">盈利、成长、市场估值、持股结构等财务类因子；</td>
                      <td>10</td>
                  </tr>
                  <tr>
                      <td>财务类-财务质量</td>
                      <td>11</td>
                  </tr>
                  <tr>
                      <td>财务类-成长性</td>
                      <td>5</td>
                  </tr>
                  <tr>
                      <td>财务类-盈利预测</td>
                      <td>4</td>
                  </tr>
                  <tr>
                      <td>财务类-市场估值</td>
                      <td>9</td>
                  </tr>
                  <tr>
                      <td>公司资料类-持股结构</td>
                      <td>3</td>
                  </tr>
                   <tr>
                      <td>另类因子</td>
                      <td>估值线买点、强弱度等特色因子；</td>
                      <td>9</td>
                  </tr>
                
                  <tr>
                      <td rowspan="4" style="text-align:center">可转债因子</td>
                      <td>市场估值类</td>
                      <td rowspan="4">可转债估值、量价、正股特征等常用因子和BS定价期权价值/溢价率等特色因子；</td>
                      <td>23</td>
                  </tr>
                  <tr>
                      <td>量价类</td>
                      <td>8</td>
                  </tr>
                  <tr>
                      <td>正股财报类</td>
                      <td>9</td>
                  </tr>
                  <tr>
                      <td>正股量价类</td>
                      <td>6</td>
                  </tr>
                      <tr class="kongbai">
                        <td td colspan="3" style="text-align:right;padding-right:10px">因子总计</td>
                        <td style="color: rgb(40, 124, 238);font-weight: bold;font-size: 18px;text-align:center;padding-right:0">133</td>
                      </tr>
                    </table> 
                </div>
               
                <div v-if="id == 1">
                    
                    <div class="paragraph">
                        开创性的多因子策略构建平台，在因子数据处理、调仓机制做了创新性改进，还支持引入独有的多因子估值数据来优化买卖点，来优化策略，提高收益率、回撤比等指标的表现。
                    </div>
                    <div class="paragraph">
                        1、对因子数据智能化处理
                    </div>
                    <div class="paragraph">
                        系统实现了对因子数据的去极值、缺失值、标准化、中性化、正交化、方向判断等的智能化处理，所有因子可直接使用，提高了策略研发效率。
                    </div>
                    <BaseBigimg
                      :src="require('./imageswh10/tsgn1.jpg')"
                    ></BaseBigimg>   
                    <div class="paragraph">
                        2、创新性的调仓机制
                    </div>
                    <div class="paragraph">
                        系统设计了更加符合交易逻辑的调仓规则，每次轮动交易时调仓的股票数量改为可控参数，降低了调仓成本，可操作性更强，更加贴合实际交易习惯。
                    </div>
                    
                    <BaseBigimg
                      :src="require('./imageswh10/tsgn2.jpg')"
                    ></BaseBigimg> 
                    <div class="paragraph">
                        3、启动止损优化收益
                    </div>
                    <div class="paragraph">
                        创新性的在调仓过程中加入了估值数据判断，有效防止调仓时买入市场热度处于峰值的股票，且能够在股票热度衰减初期，下跌趋势出现之前及时止盈，显著提高策略收益。
                    </div>
                    <BaseBigimg
                      :src="require('./imageswh10/tsgn7.jpg')"
                    ></BaseBigimg>
                    <div class="paragraph">
                        4、多维度的回测报告
                    </div>
                    <div class="paragraph">
                        系统提供了多维度的回测报告，涵盖收益分析、回测分析、收益归因、行业分布、交易分析、历史持仓列表、最新持仓列表、因子贡献度分析等多维度的数据和图表信息，可直观了解策略收益风险水平和交易情况。其中收益归因还支持了Brinson行业归因和Barra风格归因。
                    </div>
                    <BaseBigimg
                      :src="require('./imageswh10/tsgn4.jpg')"
                    ></BaseBigimg>
                    <div class="paragraph">
                       Brinson行业归因：展示回测区间策略的超额收益分解情况，把握策略超额收益主要来源于行业内选股收益还是行业本身的配置收益。
                    </div>
                    <BaseBigimg
                      :src="require('./imageswh10/tsgn5.png')"
                    ></BaseBigimg> 
                    <div class="paragraph">
                        Barra风格归因：将策略的绝对收益/超额收益，分解到十类典型的风格因子上，如价值风格、成长风格等，进而分析风格暴露情况对策略收益的影响。
                    </div>
                    <BaseBigimg
                      :src="require('./imageswh10/tsgn6.png')"
                    ></BaseBigimg>    
                    <p class="paragraph">
                        注：系统还支持市场中性化策略的构建，提供市值对冲、期货Beta对冲，系统性风险对冲三种对冲策略。
                    </p> 
                </div>
                <div v-if="id == 2">
                    <div class="paragraph">
                        传统的量价类因子、财务类因子可能无法全面捕捉市场的动态和复杂性，稀缺独特的另类因子是投资者获取超额收益、不断提升业绩的致胜性因素。
                    </div>
                    <div class="paragraph">
                        目前，<common-data name="appShortName_37"/>提供以下另类数据，未来还将逐渐更新并提供更多的特色另类数据。
                    </div>
                    <div class="paragraph">
                        1、多因子估值数据：
                    </div>
                    <div class="paragraph">
                        通过股票多因子估值数据可以获得更精准的股票估值水平信息。一方面可以通过低估值水平分析和构建中长期价值投资策略；另一方面也可以通过高估值水平精选市场关注度高、交易惯性强的股票，结合技术分析捕捉趋势机会，获取更高收益。
                    </div>
                    <div class="paragraph">
                        该数据可通过get_balanced_price函数调用。
                    </div>
                    <BaseBigimg
                      :src="require('./imageswh10/llsj1.jpg')"
                    ></BaseBigimg>
                    <div class="paragraph">
                        2、日内统计数据：
                    </div>
                    <div class="paragraph">
                        通过tick、1分钟、15分钟、30分钟等高频分钟线数据挖掘得到的在日内具有高信息增益的数据，可以及时准确的捕捉市场动向、挖掘待涨股票，帮助用户制定更准确的选股策略。
                    </div>
                    <div class="paragraph">
                        该数据可通过get_intraday_statistics函数调用。
                    </div>  
                    <BaseBigimg
                      :src="require('./imageswh10/llsj3.jpg')"
                    ></BaseBigimg>   
                </div>
                <div v-if="id == 3">
                    <div class="paragraph">
                        <common-data name="appShortName_37"/>基于多因子估值数据库，提供开源的股票多因子策略案例，策略年化收益率超过20%，同时持仓100支股票，理论上能够管理10亿资金规模。
                    </div>
                    <div class="paragraph">
                        投资者可以参考系统策略的构建方法，建立自己的多因子策略，避开同质化策略可能造成的“交易堵车”。
                    </div>
                    <BaseBigimg
                      :src="require('./imageswh10/clal1.jpg')"
                    ></BaseBigimg>
                    <div class="paragraph">
                      软件也提供市场中性、以及可转债策略等多种策略案例。
                    </div>
                    <div class="paragraph">
                        具体策略细节描述，详见【<common-data name="appShortName_37"/>-选股-案例】。
                    </div>
                    <div class="paragraph">
                       未来，<common-data name="appShortName_37"/>也将与时俱进，及时更新进行更多案例的上传和更新。
                    </div>
                    <BaseBigimg
                      :src="require('./imageswh10/clal2.jpg')"
                    ></BaseBigimg>
                </div>
                
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="loading" v-if="showloading">
        <img src="../assets/img/loading.gif" alt="" style="position:absolute;top:42%;left:50%;">
      </div> -->
      <!-- <BaseHover :message="message" v-show="!!message" class="basehover" :style="{left:left+'px',top:top+'px'}"></BaseHover>
      <BaseAlert @close="close" v-if="showalert"></BaseAlert> -->
    </div>
  </template>
  <script>
  import axios from "axios";
  import Svgg from "../../components/Svgg.vue";
  import Basecharts from "../../components/Basecharts.vue";
  import BaseHover from "../../components/BaseHover.vue";
  import BaseAlert from "../../components/BaseAlert.vue";
  
  export default {
    components: {
      Basecharts,
      BaseHover,
      BaseAlert,
      Svgg,
    
    },
    watch: {
      // "currentComponent": {
      //   handler: function (newd) {
      //     console.log(newd)
      //     console.log(document.documentElement.getElementsByClassName('img_center')[0])
      //   },
      //   deep:true,
      //   immediate:true,
      // },
      "$route.query.id": {
        handler: function (newd) {
          console.log(newd);
        },
        deep: true,
        immediate: true,
      },
    },
    created() {
      console.log(this.$route.query.id);
    },
    data() {
      return {
        id: 0,
        contentList: [
          {
            name: "开源因子库",
            id: 0,
          },
          {
            name: "可视化策略构建平台",
            id: 1,
          },
          {
            name: "另类数据",
            id: 2,
          },
          {
            name: "策略案例",
            id: 3,
          },
        
          
        ],
        
      };
    },
    methods: {
      selectContent(id) {
        this.id = id;
      },  
    },
  };
  </script>
  <style scoped src="./index.css"></style>
  <style scoped>
.trans {
  transform: rotate(180deg);
}
.container {
  padding-top: 50px;
  height: 100%;
  min-height: 400px;
  background: url(https://wh-api.wenhua.com.cn/api/WhBanner/GetWhBannerUrl?id=82) no-repeat top,
    url(../../assets/img/bgonepp.jpg) repeat-y center top 1134px;
  text-align: left;
}
.loading {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.2);
  z-index: 999;
}
.content {
  color: rgb(132, 133, 135);
  border-radius: 10px 10px 0 0;
  width: 100%;
  height: 100%;
  min-height: 600px;
  /* margin-left: 40px; */
  background: #fff;
  box-shadow: -1px 0px 3px 0px rgba(209, 222, 238, 0.9);
  
  font-size: 17px;
}
.tab ul li {
  width: 222px;
}
.text-title {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  /* width: 1096px; */
  margin: 0 60px;
}
.text-txt {
  padding-top: 5px;
  font-size: 15px;
  min-height: 600px;
  background: #f6f9fe;
  margin-top: 3px;
  padding-bottom: 40px;
  border-radius:  10px 10px 0 0;
}
.tit-left {
  display: flex;
  flex-direction: row;
}
.right-tip {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  width: 1005px;
  margin: 0 auto;
  cursor: pointer;
}
.right-tip div {
  padding: 2px 4px;
}
/* .right-tip div.active{
  color: white;
  background: #4b63f7;
} */
.tit-left-item {
  cursor: pointer;
  /* padding: 6px 18px; */
  position: relative;
  color: #181818;
}
/* .tit-left-item.active{
  color: #4b63f7;
  border-bottom: 3px solid #4b63f7;
} */
.txt-left-item {
  cursor: pointer;
  margin: 0 18px;
  padding: 3px 0px;
  font-size: 16px;
}
.txt-left-item:hover {
  color: #536b99;
}
.txt-left-item.active {
  color: #5268cd;
  border-bottom: 3px solid #5268cd;
  font-weight: bold;
}
.txt-img {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  flex-wrap: wrap;
  width: 1029px;
  margin: 0 auto;
  margin-top: 5px;
}
.base-ech {
  margin: 0px 12px;
  margin-bottom: 26px;
}
.txt-title {
  display: flex;
  flex-direction: row;
  /* margin-left: 50px; */
}
.txt-table {
  margin-top: 5px;
}








.buytable {
  margin-top: 15px;
  width: 760px;
  margin:  0 auto;
  margin-bottom: 20px;
  background: white;
}

.buytable tr {
  /* height: 35px; */
  vertical-align: middle;
  color: #4c4c4c;
  font-size: 14px;
}
.buytable tr:first-child > td {
  padding: 6px 0 !important;
  line-height: 24px;
}
.buytable td {
  padding-left: 50px;
  vertical-align: middle;
  line-height: 20px;
  color: #4d4d4d;
}
.buytable tr td:first-child {
  padding-left: 0px;
  text-align: center;
}
.buytable2 td{
  line-height: 20px;
  padding: 8px 0;
  text-align: center !important;
  padding-right: 0 !important;
}

.lightTr {
  background: #f7f7f7;
}
.buytable tr:first-child {
  /* height: 40px;
  line-height: 40px; */
  background: url(../../assets/img/table_title.png)no-repeat center;
  background-size: 100% 100%; 
  text-align: center;
  color: #fff;
  font-size: 14px;
  font-weight: bold;
}
.buytable tr:first-child td {
  padding-left: 0;
  color: inherit;
}
.buytable tr td:nth-last-child(4) {
  /* background: #fef7fa; */
  text-align: justify;
  padding:2px 10px;
}
.buytable tr td:nth-last-child(3) {
  /* background: #fef7fa; */
  text-align: justify;
  padding:4px 8px;
}
.buytable tr td:nth-last-child(2) {
  /* background: #fffff9; */
  text-align: justify;
  padding: 4px 8px;
}
/* .buytable tr td:nth-last-child(2) {
  text-align: center;
  padding-left: 0;
} */
.buytable tr td:nth-last-child(1) {
  /* background: #fffff9; */
  text-align: center;
  padding-left: 0;
}
.firstline td:first-child {
  text-align: center;
  padding: 0 !important;
}
/*.firstline td:nth-child(2){
  background: none  !important;
}
.firstline td:nth-child(3){
  background: #fef7fa !important;
}
.firstline td:nth-child(4){
  background: #fffff9;
} */
.col td {
  background: white !important;
  text-align: left !important;
  padding-left: 50px !important;
}
.col td:last-child {
  padding-left: 90px !important;
}
.buytable td {
  border: 1px solid #e6e4e4;
  border-bottom: 1px solid #bcbaba;
}

  </style>